export const DEFAULT_STYLE_VALUES = {
  // Layout
  display: 'block',
  position: 'relative',
  float: 'none',
  clear: 'none',
  visibility: 'visible',
  overflow: 'visible',
  
  // Box Model
  width: 'auto',
  height: 'auto',
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px',
  paddingTop: '0px',
  paddingRight: '0px',
  paddingBottom: '0px',
  paddingLeft: '0px',
  // Visual
  backgroundColor: 'transparent',
  color: '#000000',
  opacity: '1',
  
  // Typography
  fontSize: '16px',
  fontWeight: 'normal',
  lineHeight: 'normal',
  textAlign: 'left',
  
  // Border
  border: 'none',
  borderRadius: '0',
  
  // Transform
  transform: 'none',
  
  // Transition
  transition: 'all 0.3s ease',
  
  // Flexbox
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  flexWrap: 'nowrap',
  flex: '0 1 auto',
  
  // Grid
  gridTemplateColumns: 'none',
  gridTemplateRows: 'none',
  gap: '0',
  
  // Position
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto',
  zIndex: 'auto',
}; 